import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Lonely404 from "../assets/Lonely 404.json";  // correct import

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">

        {/* Message */}
        <div className="mb-8">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-xl text-gray-600 mb-2">
            The page you're looking for seems to have wandered off.
          </p>
          <p className="text-gray-500">
            Don't worry, even the best explorers get lost sometimes.
          </p>
        </div>

        {/* Lottie Animation */}
        <div className="mb-10 flex justify-center">
          <Lottie
            animationData={Lonely404}
            loop
            autoplay
            style={{ height: 260, width: 260 }}
          />
        </div>

        {/* Help Section */}
        <div className="mt-8 p-4 bg-white rounded-2xl shadow-lg border border-gray-100">
          <p className="text-gray-600 mb-2">Need help?</p>
          <div className="flex flex-wrap justify-center gap-2">
            <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
              Contact Support
            </button>
            <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm">
              Report Issue
            </button>
            <button
              onClick={() => navigate("/")}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm"
            >
              Go to Home
            </button>
          </div>
        </div>

        {/* Floating elements */}
        <div className="fixed top-10 left-10 w-4 h-4 bg-blue-400 rounded-full opacity-20 animate-float"></div>
        <div className="fixed top-20 right-20 w-6 h-6 bg-purple-400 rounded-full opacity-30 animate-float delay-100"></div>
        <div className="fixed bottom-20 left-20 w-3 h-3 bg-pink-400 rounded-full opacity-40 animate-float delay-200"></div>
        <div className="fixed bottom-10 right-10 w-5 h-5 bg-green-400 rounded-full opacity-25 animate-float delay-300"></div>

      </div>
    </div>
  );
};

export default NotFoundPage;
